import React, { Component } from 'react';
//import { Router, browserHistory, Route } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';


import './App.css';

import Home from './Pages/Home/Home';
import CorridasFinalizadas from './Pages/CorridasFinalizadas/CorridasFinalizadas';
import RastrearVeiculos from './Pages/RastrearVeiculos/RastrearVeiculos';
import HistoricoPA from './Pages/HistoricoPA/HistoricoPA';
import MinhaCarteira from './Pages/MinhaCarteira/MinhaCarteira';
import Login from './Pages/Login/Login';
import Perfil from './Pages/Perfil/Perfil';
import SelecioneRadio from './Pages/SelecioneRadio/SelecioneRadio';
import NotificarClientes from './Pages/NotificarClientes/NotificarClientes';
import PerfilSimples from './Pages/PerfilSimples/PerfilSimples';
import Documentos from './Pages/Documentos/Documentos';

class App extends Component {

	componentDidMount() {
		window.TaxiDigital = {};
		window.TaxiDigital.downloadFile = function (urlFile){
			var link = document.getElementById("downloadLink");
			if(link == null){
				link = document.createElement("a");
				link.id = "downloadLink";
			}
			link.href = urlFile;
			document.querySelector("body").appendChild(link);
			link.click();
		}
	}

	componentWillUnmount() {
		delete window.TaxiDigital;
	}

	render() {
		return (
			<Switch>
				<AnimatedSwitch
					atEnter={{ opacity: 0 }}
					atLeave={{ opacity: 0 }}
					atActive={{ opacity: 1 }}
					className="switch-wrapper"
				>
					<Route exact path="/" component={Home} />					
					<Route exact path="/corridas-finalizadas" component={CorridasFinalizadas} />
					<Route exact path="/rastrear-veiculos" component={RastrearVeiculos} />
					<Route exact path="/historico-pa" component={HistoricoPA} />
					<Route exact path="/minha-carteira" component={MinhaCarteira} />
					<Route exact path="/documentos" component={Documentos} />
					<Route exact path="/perfil" component={Perfil} />
					<Route exact path="/perfil-simples" component={PerfilSimples} />
					<Route exact path="/selecione-radio" component={SelecioneRadio} />
					<Route exact path="/notificar-clientes" component={NotificarClientes} />
					<Route exact path="/login" component={Login} />
					<Route exact path="/login/:ui?" component={Login} />
					<Route exact path="/login/:ui:pessoa?" component={Login} />					
					<Route exact path="/:ui?" component={Home} />
				</AnimatedSwitch>
			</Switch>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js